import { useState, useEffect } from "react";
import ReactApexChart from "react-apexcharts";
import ChartCardWithDropdown from "./ChartCardWithDropdown";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { getAdminDashboardPatientRegistrationGraph } from "../../../Redux/actions/DashboardActions";

const PatientRegisteredGraph = () => {
  let dispatch = useDispatch();
  const dashboard = useSelector((state) => state.AdminDashboard);
  const patientGraphData = dashboard?.GET_DASHBOARD_PATIENT_GRAPH_LIST;

  const [selectedFilter, setSelectedFilter] = useState(3);
  const [seriesData, setSeriesData] = useState([]);
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(false);

  const timeAnalysis = {
    series: [
      {
        name: "quantity",
        data: seriesData,
      },
    ],
    options: {
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false,
        },
        toolbar: {
          tools: {
            download: false, // Disable the download menu
          },
        },
      },
      dataLabels: {
        enabled: true,
      },
      stroke: {
        curve: "straight",
      },
      title: {
        text: "",
        align: "left",
      },
      grid: {
        row: {
          colors: ["#f3f3f3", "transparent"],
          opacity: 0.5,
        },
      },
      xaxis: {
        categories: categories,
      },
      yaxis: {
        labels: {
          show: true,
          formatter: (value) => {
            return value;
          },
        },
      },
    },
  };

  const options = [
    { value: 3, label: "Weekly" },
    { value: 2, label: "Monthly" },
    { value: 1, label: "Yearly" },
  ];

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        await dispatch(
          getAdminDashboardPatientRegistrationGraph(selectedFilter)
        );
      } catch (error) {
        console.error("Error fetching data", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [selectedFilter, dispatch]);

  useEffect(() => {
    if (patientGraphData) {
      const newSeriesData = patientGraphData.map((item) => item.count);
      const newCategories = patientGraphData.map((item) => item.key);
      setSeriesData(newSeriesData);
      setCategories(newCategories);
    }
  }, [patientGraphData]);

  const handleFilterChange = (e) => {
    setSelectedFilter(e.target.value);
  };

  return (
    <div className="my-5">
      <ChartCardWithDropdown
        options={options}
        selectedOption={selectedFilter}
        onFilterChange={handleFilterChange}
        title="Registered Patient"
      >
        {loading || dashboard?.GET_DASHBOARD_PATIENT_GRAPH_LIST_LOADING ? (
          <div
            className="d-flex justify-content-center align-items-center"
            style={{ height: 350 }}
          >
            <Spinner animation="border" />
          </div>
        ) : (
          <ReactApexChart
            options={timeAnalysis.options}
            series={timeAnalysis.series}
            type="line"
            height={350}
          />
        )}
      </ChartCardWithDropdown>
    </div>
  );
};

export default PatientRegisteredGraph;
